<template>
  <div
    v-if="title || subtitle"
    :id="textToTarget(title, 'heading-2')"
    class="mb-16 flex flex-col"
    :class="center ? 'items-center' : 'md:items-baseline'"
  >
    <h2
      :id="titleId"
      class="text-static-default-hi heading-2"
      :class="{ 'mb-8 md:mb-0 md:mr-12': subtitle }"
    >
      {{ title }}
    </h2>
    <span class="text-static-default-low body-1">
      {{ subtitle }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { textToTarget } from '@backmarket/nuxt-layer-cms/utils/textToTarget'

withDefaults(
  defineProps<{
    titleId?: string
    title?: string
    subtitle?: string | null
    center?: boolean
  }>(),
  {
    titleId: '',
    title: '',
    subtitle: '',
    center: false,
  },
)
</script>
